const formatBigNumber = (number) => {
  const newNumber = number >= 1000 ? number >= 1000000 ? Math.floor(number/1000000) + 'М' : Math.floor(number/1000) + 'K' : number
  return newNumber
}

export default formatBigNumber